const CustomAppHeadContent = () => {
  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Homemade+Apple&family=Roboto:wght@400;500&display=swap" rel="stylesheet" />
    </>
  )
}

export default CustomAppHeadContent
